import React from 'react';

interface TotalEntriesLabelProps {
  totalEntries: number;
  itemLabel: string;
}

const TotalEntriesLabel = (props: TotalEntriesLabelProps) => {
  const { totalEntries, itemLabel } = props;
  return (
    <div className="text-secondary">
      Total de {totalEntries} {itemLabel}.
    </div>
  );
};
export default TotalEntriesLabel;
